





























































import { Vue, Component, Prop, Watch, Mixins } from "vue-property-decorator";
import IpBadge from "./IpBadge.vue";
import { VIPIpComponentMixin } from '@/mixins/VIPIpMixin';

@Component({
	components: {
		IpBadge,
	}
})
export default class IpView extends Mixins(VIPIpComponentMixin) {

}
